import { ConsumePlayerService } from './ConsumePlayerService'
import { authRepository } from '../repository/AuthRepository'
import { consumePlayerApi } from '../api/ConsumePlayerApi'

export const consumePlayerService = new ConsumePlayerService(authRepository, consumePlayerApi)
